import React from 'react';
import { Box } from '@mui/material';
import QuestionCardSectionTitle from './QuestionCardSectionTitle';

/**
 * Shared body for the per-project bar sections on the numeric and boolean question
 * cards: a titled block whose bar list scrolls once it grows past ~5 projects, so a
 * client with many projects can't push the rest of the accordion out of view.
 */
const QuestionCardBarSection: React.FC<{ title: string; children: React.ReactNode }> = ({ title, children }) => (
    <Box sx={{ pl: { md: 1 } }}>
        <QuestionCardSectionTitle mb={1.5}>{title}</QuestionCardSectionTitle>
        <Box sx={{ maxHeight: 200, overflowY: 'auto', pr: 1 }}>{children}</Box>
    </Box>
);

export default QuestionCardBarSection;
